import { CustomCodeSection as CustomCodeSectionType } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import DOMPurify from 'dompurify';
import { SectionBase } from '../../content-composer/section-base/section-base';
import type { ComposerSection } from '../../content-composer/types';
import { CustomCodeOutput } from './custom-code-output';
import { CustomCodeSettings } from './custom-code-settings';
import { CustomCodeTool } from './custom-code-tool';

export const CustomCodeSection: ComposerSection<CustomCodeSectionType> = ({ code }) => {
  const sanitizedCode = DOMPurify.sanitize(code ?? '');

  return (
    <SectionBase css={{ display: 'block' }}>
      <div dangerouslySetInnerHTML={{ __html: sanitizedCode }} />
    </SectionBase>
  );
};

CustomCodeSection.craft = {
  props: {
    code: '',
    sectionType: 'CustomCodeSection',
  },
  related: {
    output: CustomCodeOutput,
    settings: CustomCodeSettings,
    tool: CustomCodeTool,
  },
};
